import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { State } from '~/Reducers'
import { getCurrentClan } from "helpers/currentAccount"
import { BATTLE_TYPES } from '../constants'
import { SEASON_TYPES } from 'reducers/ReducerClanBattles'
import { showAcceptInviteDialog, showSendApplicationDialog } from "helpers/dialog"
import { changeRequestsSeasonType, changeRequestsSeason } from "./ActionRequests";
import { fetchWithSpinner, fetchWrapper as fetch } from "helpers/fetch"
import { t } from "helpers/localization"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { push } from "react-router-redux"
import settings from "settings"
import * as web2ClientAPI from "web2ClientAPI/web2ClientAPI"
import { decreaseActiveEntriesCount, syncAccountInfo, updateAccountInfo } from "./ActionAccount"
import { getLastSeasonOfType } from "~/helpers/ladder";

export const INVITES_CHANGE_PAGE = 'INVITES_CHANGE_PAGE'
export const changePage = (page: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_CHANGE_PAGE,
    page
  })
}

export const INVITES_CHANGE_ORDER = 'INVITES_CHANGE_ORDER'
export const changeOrder = (order: string, isAsc: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_CHANGE_ORDER,
    order,
    isAsc
  })
}

export const INVITES_TOGGLE_FETCHING = 'INVITES_TOGGLE_FETCHING'
export const toggleFetching = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_TOGGLE_FETCHING
  })
}

export const INVITES_UPDATE_INVITES = 'INVITES_UPDATE_INVITES'
export const updateInvites = (data: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_UPDATE_INVITES,
    data
  })
}

export const INVITES_UPDATE_ERROR = 'INVITES_UPDATE_ERROR'
export const updateError = (error: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_UPDATE_ERROR,
    error
  })
}

export const INVITES_START_PROCESSING = 'INVITES_START_PROCESSING'
export const startProcessing = (id: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_START_PROCESSING,
    id
  })
}

export const INVITES_PROCESSING_SUCCESS = 'INVITES_PROCESSING_SUCCESS'
export const processingSuccess = (id: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_PROCESSING_SUCCESS,
    id
  })
}

export const INVITES_PROCESSING_FAILED = 'INVITES_PROCESSING_FAILED'
export const processingFailed = (id: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: INVITES_PROCESSING_FAILED,
    id
  })
}

const syncForNewClan = (dispatch, clanId, root, skipNotification = false) => {
  const messages = skipNotification ? { joinClan: () => { } } : {}
  return dispatch(syncAccountInfo(messages)).catch(() => {
    if (clanId) {
      dispatch(updateAccountInfo({
        clanId,
        role: 'private',
        activeInvitesCount: 0
      }))
    }
    dispatch(push(`${root}profile`))
  })
}

const processAcceptError = (dispatch, state, json, invite) => {
  const root = state.urls.root
  // const additionalInfo = get(json, 'additional_info', {})
  const reason = json.title.toLowerCase()

  if (reason === 'account_in_cooldown') {
    web2ClientAPI.sendAcceptInviteYouAreInClanCooldownErrorNotification(invite.clan, state.currentAccount.inClanCooldownTill)
  } else if (reason === 'account_already_in_clan') {
    web2ClientAPI.sendAcceptInviteYouAreInOtherClanErrorNotification(invite.clan)
    const clanId = get(json, 'additional_info.clan_id', null)
    return syncForNewClan(dispatch, clanId, root)
  } else if (reason === 'invite_is_not_active') {
    // const inviteStatus = additionalInfo.status
    // if (inviteStatus === 'expired') {
    web2ClientAPI.sendAcceptInviteWithExpitedStatusNotification(invite.clan)
    // }
    dispatch(decreaseActiveEntriesCount())
    return dispatch(processingSuccess(invite.id))
  } else if (reason === 'clan_already_disbanded') {
    web2ClientAPI.sendAcceptInviteClanIsDisbandedErrorNotification(invite.clan)
  } else if (reason === 'clan_is_full') {
    web2ClientAPI.sendAcceptInviteClanIsFullErrorNotification(invite.clan)
  } else {
    web2ClientAPI.sendAcceptInviteErrorWithClanInfoNotification(invite.clan)
  }

  return dispatch(processingFailed(invite.id))
}

export const acceptInvite = (invite: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState()
  const root = state.urls.root
  if (state.invites.isFetching) {
    return
  }
  dispatch(toggleFetching())

  const url = `${state.urls.invites}${invite.id}/`
  const options = {
    method: 'PATCH',
    body: { status: 'accepted' }
  }

  dispatch(startProcessing(invite.id))
  return fetch(url, options).then(json => {
    if (json.title || json.status === 'error') {
      dispatch(toggleFetching())
      return processAcceptError(dispatch, getState(), json, invite)
    }

    web2ClientAPI.sendAcceptInviteNotification(invite.clan)

    return syncForNewClan(dispatch, invite.clan.id, root, true).then(() => {
      dispatch(toggleFetching())
    })
  }, () => {
    dispatch(toggleFetching())
    return processAcceptError(dispatch, getState(), null, invite)
  })

}

const processDeclineError = (dispatch, json, root, invite) => {
  const reason = get(json, 'additional_info.reason')
  if (reason === 'account_already_in_clan') {
    const clanId = get(json, 'additional_info.clan_id', null)
    return syncForNewClan(dispatch, clanId, root)
  } else if (reason === 'invite_is_not_active') {
    dispatch(decreaseActiveEntriesCount())
    return dispatch(processingSuccess(invite.id))
  } else {
    web2ClientAPI.sendDeclineInviteErrorNotification()
    return dispatch(processingFailed(invite.id))
  }
}

export const declineInvite = (invite: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState()
  const url = `${state.urls.invites}${invite.id}/`
  const options = {
    method: 'PATCH',
    body: { status: 'declined' }
  }

  dispatch(startProcessing(invite.id))
  return fetch(url, options).then(json => {
    if (json.status === 'error') {
      return processDeclineError(dispatch, json, state.urls.root, invite)
    }

    web2ClientAPI.sendDeclineInviteNotification(invite.clan)

    dispatch(decreaseActiveEntriesCount())
    return dispatch(processingSuccess(invite.id))
  }).catch(() => {
    return processDeclineError(dispatch, null, state.urls.root, invite)
  })
}

export const fetchInvites = (withGlobalSpinner: boolean = false): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState()
  if (state.invites.isFetching) {
    return
  }

  let currentSeason = state.requests.requestsSeason
  const battleType = state.requests.requestsBattleType
  const clanSeasonType = battleType == BATTLE_TYPES.REGULAR_CVC ? SEASON_TYPES.REGULAR : battleType == BATTLE_TYPES.BRAWL_CVC ? SEASON_TYPES.BRAWL : null

  dispatch(toggleFetching());
  if (clanSeasonType && state.requests.requestsSeasonType != clanSeasonType){
      dispatch(changeRequestsSeasonType(clanSeasonType))
      currentSeason = getLastSeasonOfType(clanSeasonType).id
      dispatch(changeRequestsSeason(currentSeason))
  }

  const currentAccount = state.currentAccount
  const url = currentAccount.clanId ? state.urls.invitesClanList : state.urls.invitesAccountList
  const limit = settings.entries.limit
  const order = state.invites.sort.order
  const query = {
    battle_type: clanSeasonType ? 'cvc' : state.requests.requestsBattleType,
    order: state.invites.sort.isAsc ? order : `-${order}`,
    offset: (state.invites.page - 1) * limit,
    season_id: clanSeasonType ? currentSeason : undefined,
    limit
  }
  const promise = fetch(url, { query }).then(json => {
    if (json.error) {
      return dispatch(updateError(json))
    }
    const activeInvitesCount = get(json, '_meta_.total', currentAccount.activeInvitesCount)
    dispatch(updateAccountInfo({ activeInvitesCount }))
    return dispatch(updateInvites(json))
  }).catch(() => {
    return dispatch(updateError({ error: t('Произошла ошибка. Повторите попытку позже') }))
  })

  return withGlobalSpinner ? fetchWithSpinner(dispatch, promise, t('Загружаем приглашения')) : promise
}

const processSendError = (dispatch, json, account, currentClan, shouldFetchInvites) => {
  const reason = get(json, 'additional_info.reason')
  if (reason === 'account_does_not_meet_requirements') {
    web2ClientAPI.sendSendInviteAlreadySentNotification(account.name, currentClan)
    return shouldFetchInvites && dispatch(fetchInvites())
  } else if (reason === 'account_already_in_clan') {
    web2ClientAPI.sendSendInvitePlayerInOtherClanErrorNotification(account.name)
  } else if (reason === 'too_many_invites') {
    web2ClientAPI.sendSendInviteDailyInvitesLimitReachedErrorNotification(account.name)
  } else if (reason === 'account_banned') {
    web2ClientAPI.sendSendInvitePlayerHasPermanentBanErrorNotification(account.name)
  } else if (reason === 'insufficient_permissions') {
    const additionalInfo = json.additional_info
    if (additionalInfo.role) {
      web2ClientAPI.sendSendInvitePermissionsErrorNotification(account.name)
    } else {
      web2ClientAPI.sendSendInviteYouAreNotInClanNotification(account.name, currentClan)
    }
  } else if (reason === 'clan_is_full') {
    web2ClientAPI.sendSendInviteClanIsFullErrorNotification(account.name, currentClan)
  } else {
    web2ClientAPI.sendSendInviteErrorWithPlayerInfoNotification(account.name)
  }
}

export const sendInvite = (account: any, shouldFetchInvites: boolean = false): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState()
  const url = state.urls.invites
  const currentClan = getCurrentClan(state)

  return fetchWithSpinner(dispatch, fetch(url, {
    method: 'POST',
    body: {
      recipient_id: account.id,
      source: 'clans_portal.recruitstation'
    }
  }).then(json => {
    if (json.status === 'error' || json.error || json.errors) {
      return processSendError(dispatch, json, account, currentClan, shouldFetchInvites)
    } else {
      web2ClientAPI.sendSendInviteNotification(account.name, currentClan)
      return shouldFetchInvites && dispatch(fetchInvites())
    }
  }, () => {
    processSendError(dispatch, null, account, currentClan, shouldFetchInvites)
  }))
}

export const joinClan = (clan: any, invite: any, applicationSource: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const invitePromise = isEmpty(invite) ? fetchActiveInviteFromClan(clan.id, getState().urls.activeInvite) : Promise.resolve({
    id: invite.id,
    clan
  })
  return invitePromise.then(invite => {
    if (invite) {
      return dispatch(showAcceptInviteDialog(invite))
    } else {
      return dispatch(showSendApplicationDialog(clan, applicationSource))
    }
  })
}

const fetchActiveInviteFromClan = (clanId, url) => fetch(url.replace('{clan_id}', clanId)).then(json => (json._meta_ && json[json._meta_.model]), () => { })